import { useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import DelayLink from '@/components/DelayLink'
import { decodeEntities } from '@/utils/decodeEntities'
import style from './style'

const useStyles = createUseStyles(style)

const ProductItem = ({
  item,
  layout,
  externalLink,
}) => {
  const classes = useStyles()
  const [hover, setHover] = useState(false)

  const mediaQueryKey = useSelector((state) => state.mediaQuery.key)

  const handleMouseMove = (e) => {
    if (e.type === 'mouseenter' && !hover && mediaQueryKey > 1) setHover(true)
    if (e.type === 'mouseleave' && hover && mediaQueryKey > 1) setHover(false)
  }

  return (
    <DelayLink
      to={item.link}
      className={classNames({
        [classes.root]: true,
        productItem__root: true,
        [classes.hover]: hover,
        [classes[layout]]: layout,
        productItem__hover: hover,
      })}
    >
      <div
        className={`${classes.wrapper} productItem__wrapper`}
        onMouseEnter={(e) => handleMouseMove(e)}
        onMouseLeave={(e) => handleMouseMove(e)}
      >
        <div className={`${classes.imageWrapper} productItem__imageWrapper`}>
          <div className={`${classes.image} productItem__image`}>
            {item.image ? (
              <img src={item.image} alt={item.title} />
            ) : null}
          </div>
        </div>
        <div className={`${classes.info} productItem__info`}>
          {externalLink && (
            <svg className={classes.iconLink}>
              <title>External Link</title>
              <use xlinkHref="#ico-link" />
            </svg>
          )}
          <div
            className={`${classes.title} productItem__title`}
            dangerouslySetInnerHTML={{ __html: decodeEntities(item.title) }}
          />
          <div
            className={`${classes.denomination} productItem__denomination`}
            dangerouslySetInnerHTML={{ __html: decodeEntities(item.denomination) }}
          />
        </div>
        <div className={`${classes.icon} productItem__icon`}>
          <svg><use xlinkHref="#ico-arrow-right" /></svg>
        </div>
      </div>
    </DelayLink>
  )
}

ProductItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    denomination: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    image: PropTypes.string,
  }).isRequired,
}

export default ProductItem
